import { Component, AfterViewInit, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialogRef } from '@angular/material/dialog';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { ModalpopService } from '../modalpop.service';
import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
@Component({
  selector: 'app-additional-details',
  templateUrl: './additional-details.component.html',
  styleUrls: ['./additional-details.component.scss']
})
export class AdditionalDetailsComponent implements OnInit, AfterViewInit {
  @Output() next = new EventEmitter<void>();
  @Output() prev = new EventEmitter<void>();
  @Output() first = new EventEmitter<void>();
  @Input() tabName: string = '';
  dialogRef: MatDialogRef<any>;
  maxdate: any;
  minDate: any;
  maxdate2: any;
  minDate2: any;
  disabled = false;
  tabs : string;
  displayName : any;
  Course: any;
  College: any;
  EmpTypeCodeList: any;
  filteredListEmpTypeCode: any;
  districtList: any[];
  filteredListdistrictCode: any[];
  collegedataList: any;
  filteredListCollege: any;
  MediumCodeList: any;
  filteredListMediumCode: any;
  constructor(private fb: FormBuilder, public umsService: UmsService, public datepipe: DatePipe,
    private modalPopupService: ModalpopService,
    private spinner: NgxSpinnerService) { }

  additionalDetailsForm: FormGroup;
  submitButton = true;
  updateButton = false;
  AdharPhone = false;
  AadharCard = false;
  AbcId = false
  additionalDetailsFormArray;
  StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
  AdditionalShow = false;
  calledApi = 0; // Total number of APIs called
  finishedApi = 0; // Total number of APIs completed (success or failure)
  ngOnInit(): void {
    this.maxdate = new Date();
    this.minDate = new Date(2010, 0, 1);
    this.disabled = false;
    this.maxdate2 = new Date();
    this.minDate2 = new Date(2010, 0, 1);
    this.submitButton = true;
    this.updateButton = false;
    this.AdharPhone = false;
    this.AadharCard = false;
    this.AbcId = false
    // this.loadsettingspage()
    this.StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
    this.additionalDetailsForm = this.fb.group({
      StuId: new FormControl(this.StudentPersonalId),
      StuExtraId: new FormControl(),
      StuWorkExp: [''],
    });
    this.spinner.show();
    this.getScrutiny();
    this.getApplyData();
    this.fetchEmpType();   //to be added again when asked later for other universities too
    this.fetchMedium();    //to be added again when asked later for other universities too
    this.getDistrictData();    //to be added again when asked later for other universities too
    this.prepopulation();
   
  }
  ngAfterViewInit(): void {
    // this.loadsettingspage();
    // this.prepopulation();
    // this.fetchEmpType();   //to be added again when asked later for other universities too
    // this.fetchMedium();    //to be added again when asked later for other universities too
    // this.getDistrictData();    //to be added again when asked later for other universities too
  }

  getScrutiny() {
    this.calledApi++
    const payload = {};
    payload['StudentId'] = sessionStorage.getItem('StudentPersonalId');
    this.umsService.fetchScrutinyLock(payload).subscribe(res => {
      if(res.status){
        this.tabs = res.data[0].Tabs;
        
          if (res.data.length == 0 || res.data[0]['Status'] == 'DCERR') {
          if(res.data[0].Tabs.includes('Additional Details')){
            this.disabled = false;
          }else{
            this.disabled = true;
          }
        }
        else {
          this.disabled = true;
        }
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
      else{
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
  }

  fetchDate(item) {
    // StuFromDate
    if (item[0].StuFromDate == "1970-01-01" && item[0].StuToDate == "1970-01-01") {
      item[0].StuFromDate = '';
      item[0].StuToDate = ''
    }
  }

  prepopulation() {
    this.calledApi++
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    this.umsService.fetchAdditionalDetails(payload).subscribe(async(res) => {
      if (res.status) {
        this.additionalDetailsForm.get('StuWorkExp')?.setValue(res.data[0].StuWorkExp);
        if(res.data[0].StuABCId == 2){
          this.AdharPhone = true;
          this.AbcId = false
        }
        else if(res.data[0].StuABCId == 1){
          this.AdharPhone = false;
          this.AbcId = true
        }

        if(res.data[0].StuAadhar == 1){
          this.AadharCard = true
        }
        else if(res.data[0].StuAadhar == 2){
          this.AadharCard = false
        }
        
        await this.fetchDate(res.data)
        await this.fetchEmpType();   //to be added again when asked later for other universities too
        await this.fetchMedium();    //to be added again when asked later for other universities too
        await this.getDistrictData();    //to be added again when asked later for other universities too
        await this.getCollegeData(res.data[0].StuDistrictAd)
        if (res.data.length > 0) {

          this.umsService.disable5 = false;
          sessionStorage.setItem("StudentPersonalId", res.data[0].StuId);
          this.submitButton = false;
          this.updateButton = true;
          //  StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
          await this.prepopulatedatapage(res);
        } else {
          await this.loadsettingspage();
        }
      } else {
        
        await this.loadsettingspage();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    })
  }


  prepopulation2() {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    this.umsService.fetchAdditionalDetails(payload).subscribe((res) => {
      if (res.status) {
         this.spinner.hide();
        if (res.data.length > 0) {
          this.umsService.disable5 = false;
          //   sessionStorage.setItem("StudentPersonalId",res.data[0].StuId);
          //   this.submitButton = false;
          //   this.updateButton = true;
          //  //  StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
          //    this.prepopulatedatapage(res);
        } else {
          //  this.loadsettingspage();
          this.umsService.disable5 = true;
        }
      } else {
        this.spinner.hide();
        this.loadsettingspage();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

  prepopulatedatapage(e) {
    let payload = {};
    payload['FormPage'] = 'AdditionalDetail';
    this.additionalDetailsForm.controls['StuExtraId'].setValue(e.data[0]['StuExtraId']);
    this.umsService.getStdSetting(payload).subscribe((ress) => {
      ress.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.additionalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], Validators.required));

            } else {
              this.additionalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], [Validators.required, Validators.pattern(element.FormPattern)]));

            }
          } else {
            if (element.FormPattern == '') {
              this.additionalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
            }
            else {
              this.additionalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], [Validators.pattern(element.FormPattern)]));
            }
          }
        } else {
          this.additionalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
        }
      });
      this.additionalDetailsFormArray = ress.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
      this.AdditionalShow = true;
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
  }

  loadsettingspage() {
    let payload = {};
    payload['FormPage'] = 'AdditionalDetail';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      res.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.additionalDetailsForm.addControl(element.FormControlName, new FormControl('', Validators.required));
            } else {
              this.additionalDetailsForm.addControl(
                element.FormControlName,
                new FormControl('', [Validators.required, Validators.pattern(element.FormPattern)])
              );
            }

          } else {
            if (element.FormPattern == '') {
              this.additionalDetailsForm.addControl(element.FormControlName, new FormControl(''));
            } else {
              this.additionalDetailsForm.addControl(element.FormControlName, new FormControl('', [Validators.pattern(element.FormPattern)]));
            }
          }
        }
      });
      this.additionalDetailsFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
      this.AdditionalShow = true;
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
  }

  SubmitFormarkAsTouched() {
    this.spinner.show() 
    let payload = {};
    payload['FormPage'] = 'AdditionalDetail';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      this.spinner.hide()
      res.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            const control = this.additionalDetailsForm.get(element.FormControlName);
            if (control) {
              console.log("controooooooo",this.additionalDetailsForm);
              
              control.markAsTouched();
            }
            // if (element.FormControlName == 'StuAadhar' && this.additionalDetailsForm.value.StuAadhar == 1) {
            //   this.additionalDetailsForm.get('StuAadhaarNo').markAsTouched();
            // }
          }
        }
      });
      this.additionalDetailsFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  submitAdditionalDetails() {
    if (this.additionalDetailsForm.invalid) {
       this.SubmitFormarkAsTouched();
    }
    else {
      this.spinner.show();
      let payload = this.additionalDetailsForm.value;
       payload.StuOrgDonate = parseInt(payload.StuOrgDonate);
      payload.StuHostelAccod = parseInt(payload.StuHostelAccod);
      payload.StuFmlyInc = parseInt(payload.StuFmlyInc);
      payload['LoginId'] = parseInt(sessionStorage.getItem('StudentRGID'))
      let da = this.additionalDetailsForm.value.StuFromDate;
      payload['StuFromDate'] = this.datepipe.transform(da, 'yyyy-MM-dd');
      let da1 = this.additionalDetailsForm.value.StuToDate;
      payload['StuToDate'] = this.datepipe.transform(da1, 'yyyy-MM-dd');
      if(payload['StuWorkExp'] == ''){
        payload['StuWorkExp'] = "0"
      }
       this.umsService.addAdditionalDetails(payload).subscribe(res => {
        if(res.status){
          this.spinner.hide();
          let data = {}
          data['message'] = res.message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
          this.next.emit();
        }
        else{
          this.spinner.hide();
        }
         }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);

      });
    }

  }
  // getTabName(e){
  //   this.displayName = e;
  // }
  getTabDisplayName(): string {
    return `Current Tab: ${this.tabName}`;
  }
  UpdScrtDetails(){
    this.spinner.show();
    let payload = {};
    payload['StuId'] = parseInt(this.StudentPersonalId)
    payload['SessionId'] = parseInt(sessionStorage.getItem('session'));
    payload['CgCode'] = this.College
    payload['CoCode'] = this.Course
    this.umsService.UpdScrtDetails(payload).subscribe((res) => {
      if(res.status){
        this.first.emit();
        location.reload();
        this.spinner.hide();
      }
      else{
        this.spinner.hide();
        
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }
  getApplyData(){
    this.calledApi++
    let payload = {}
    payload['LoginId'] = sessionStorage.getItem('loginId');
    this.umsService.getApplyData(payload).subscribe((res) => {
      if(res.status){
       this.Course = res.data[0]['Course'];
       this.College = res.data[0]['College'];
       this.finishedApi++; // Increment the finished API count
       if (this.finishedApi === this.calledApi) {
         this.spinner.hide();
       }
      }
      else{
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
  }

  updateAdditionalDetails() {
    if (this.additionalDetailsForm.invalid) {
         this.SubmitFormarkAsTouched();
    } 
    else {
      if(this.tabs){
        const lastTab: string = this.tabs.split(', ').pop() || '';
        if( this.tabName == lastTab){
            const data = {};
            data['message'] = 'Are You Sure You Have Updated ' + this.tabs + ' Tabs. Do You Want To Proceed?';
            data['title'] = 'Alert';
            data['icon'] = 'fa fa-question';
            this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
            this.dialogRef.afterClosed().subscribe(result => {
              if (result === 'yes') {
                this.UpdScrtDetails();
                this.Update();
              } else {
                this.dialogRef.close();
                  // Do something else if needed
              }
          });
          }
          else{
           this.Update();
          }
        }
        else{
          this.Update();
         }
    }

  }

  Update(){
    this.spinner.show();
    let payload = this.additionalDetailsForm.value;
     payload.StuOrgDonate = parseInt(payload.StuOrgDonate);
    payload.StuHostelAccod = parseInt(payload.StuHostelAccod);
    payload.StuFmlyInc = parseInt(payload.StuFmlyInc);
    payload['LoginId'] = parseInt(sessionStorage.getItem('StudentRGID'))
    let da = this.additionalDetailsForm.value.StuFromDate;
    payload['StuFromDate'] = this.datepipe.transform(da, 'yyyy-MM-dd');
    let da1 = this.additionalDetailsForm.value.StuToDate;
    payload['StuToDate'] = this.datepipe.transform(da1, 'yyyy-MM-dd');
    if(payload['StuWorkExp'] == ''){
      payload['StuWorkExp'] = "0"
    }
    this.umsService.updateAdditionalDetails(payload).subscribe(res => {
      if(res.status){
      this.spinner.hide();
      let data = {}
      data['message'] = res.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      this.next.emit();
      }else{
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  back() {
    this.prev.emit();
  }

  todate(event: any) {
    let dateeee = this.additionalDetailsForm.value.StuToDate;
    let toDate = this.datepipe.transform(dateeee, 'yyyy-MM-dd');
    if (this.additionalDetailsForm.value.StuFromDate == '' || this.datepipe.transform(this.additionalDetailsForm.value.StuFromDate, 'yyyy-MM-dd') == '') {
      let data = {}
      data['message'] = "Select Valid From Date"
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      this.additionalDetailsForm.controls['StuToDate'].setValue('');
    }
    else if (this.additionalDetailsForm.value.StuFromDate >= toDate || this.datepipe.transform(this.additionalDetailsForm.value.StuFromDate, 'yyyy-MM-dd') >= toDate) {
      let data = {}
      data['message'] = "Valid Till Date should Not Less Than From Date"
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      this.additionalDetailsForm.controls['StuToDate'].setValue('');

    }
  }

  fetchEmpType() {
    this.calledApi++
    const payload = {};
    payload['CdType'] = 'ET';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.EmpTypeCodeList = res.data;
        this.filteredListEmpTypeCode = this.EmpTypeCodeList.slice();
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      } else {
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    })
  }

  AdharContact(value){
    console.log('value',value);
    if(value == 2){
      this.AdharPhone = true;
      this.AbcId = false
    }
    else if(value == 1){
      this.AdharPhone = false;
      this.AbcId = true
    }
    
  }

  Aadhar(value){ 
    if(value == 1){
      this.AadharCard = true
    }
    else if(value == 2){
      this.AadharCard = false
    }
  }

  getDistrictData() {
    this.calledApi++
    const payload = {};
    this.umsService.getDistrict(payload).subscribe(res => {
      if(res.status){
        this.districtList = res.data;
        this.filteredListdistrictCode = this.districtList.slice();
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
      else{
        this.districtList = []
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
  }

  getCollegeData(dsCode) {
    this.calledApi++
    this.collegedataList =[];
    this.filteredListCollege=[]
    const payload = {};
    payload['DsCode'] = dsCode
    this.umsService.DistrictWiseCollege(payload).subscribe((res) => {
      if(res.status){
        this.collegedataList = res.data;
        this.filteredListCollege = this.collegedataList.slice();
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
      else{
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
       
    },(ERROR: HttpErrorResponse) => {
      this.collegedataList = [];
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    })
  }

  fetchMedium() {
    this.calledApi++
    const payload = {};
    payload['CdType'] = 'ME';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.MediumCodeList = res.data;
        this.filteredListMediumCode = this.MediumCodeList.slice();
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      } else {
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    })
  }

    // Custom validator applied in the template
    validateWorkExp(control: AbstractControl): boolean {
      const value = control.value;
      if (!value) return true; // Allow empty values
      return /^[0-9]+$/.test(value) && parseInt(value, 10) >= 0 && parseInt(value, 10) <= 50;
    }
  
    // Prevent invalid keypresses
    validateKeyPress(event: KeyboardEvent): void {
      const allowedKeys = /^[0-9]$/;
      if (!allowedKeys.test(event.key)) {
        event.preventDefault();
      }
    }
}